import React from "react";
import { motion } from "framer-motion";

export default function Reveal() {
  return (
    <section
      data-testid="reveal-section"
      className="relative w-full py-32 sm:py-40 px-6 bg-[#141414] overflow-hidden"
    >
      <div className="absolute inset-0 vignette pointer-events-none" />
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0 }}
          className="text-xs tracking-[0.4em] uppercase text-[#C4451C] mb-6"
        >
          the reveal
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.2 }}
          className="font-marker text-[#E8E5DE] text-4xl sm:text-5xl md:text-6xl leading-[1.05]"
        >
          There's a reason
          <br />
          we made this site.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.2, delay: 0.15 }}
          className="text-lg sm:text-2xl text-[#E8E5DE] mt-8 leading-relaxed"
        >
          We don't hate wood mulch because it's wood. We hate it because
          there's something better — and most people have never been told.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 text-left"
        >
          {[
            ["Recycled", "Made from end-of-life tires — diverted from landfills."],
            ["Stable", "Doesn't fade, rot, attract termites, or feed fires the same way."],
            ["Lasts 20+ years", "Replace it once. Live with it for two decades."],
            ["Safer ground", "Used under playgrounds for cushioned, low-dust impact."],
          ].map(([k, v], i) => (
            <div
              key={i}
              className="border border-[#262626] p-5 bg-[#0F0F0F]"
              data-testid={`reveal-fact-${i}`}
            >
              <div className="font-marker text-2xl text-[#C4451C] mb-1">{k}</div>
              <div className="text-sm text-[#A3A3A3]">{v}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
